import { Vue } from 'vue-property-decorator';

function getDiffString(diff: number): string {
    const seconds = Math.floor(diff / 1000) % 60;
    const minutes = Math.floor(diff / (1000 * 60)) % 60;
    const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    const pluralize = (value: number, zero: string, one: string, few: string, many: string) => {
        if (value === 0) return zero;
        if (value === 1) return `${value} ${one}`;
        if (value >= 2 && value <= 4) return `${value} ${few}`;
        return `${value} ${many}`;
    };

    if (days > 0) {
        let result = pluralize(days, '', 'den', 'dny', 'dní');
        if (hours > 0) {
            result += ` a ${pluralize(hours, '', 'hodina', 'hodiny', 'hodin')}`;
        }
        return result.trim();
    } else if (hours > 0) {
        let result = pluralize(hours, '', 'hodina', 'hodiny', 'hodin');
        if (minutes > 0) {
            result += ` a ${pluralize(minutes, '', 'minuta', 'minuty', 'minut')}`;
        }
        return result.trim();
    } else if (minutes > 0) {
        return pluralize(minutes, '', 'minuta', 'minuty', 'minut');
    } else {
        return pluralize(seconds, '0 sekund', 'sekunda', 'sekundy', 'sekund');
    }
}

export function timespanToString(startDate: string, endDate?: string | undefined | null) {
    const startDateValue = new Date(startDate);
    const endDateValue = endDate ? new Date(endDate) : new Date();
    const diff = endDateValue.getTime() - startDateValue.getTime();
    return getDiffString(diff);
}

Vue.filter('timespan', (startDate: string, endDate?: string) => {
    return timespanToString(startDate, endDate);
});

Vue.filter('formatDuration', (durationMinutes: number | null | undefined) => {
    console.log(durationMinutes);
    return getDiffString((durationMinutes ?? 0) * 60 * 1000);
});
